import React from 'react' // eslint-disable-line

import styled from 'styled-components'
const tabletWidth = 1200
const mobileWidth = 980
export const Hero = styled.div`
  position: relative;
  width: 100%;
  height: 718px;
  [data-type='overlay'] {
    width: 100%;
    height: 100%;
    position: absolute;
    background-color: rgba(0, 0, 0, 0.3);
    z-index: 2;
  }
  [data-type='image'] {
    position: relative;
    width: 100%;
    height: 718px;
    overflow: hidden;
    img {
      width: 100%;
      height: 718px;
      object-fit: cover;
      object-position: center center;
    }
  }

  [data-type='header'] {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 3;
    [data-type='sub-section'] {
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
    }
    h1 {
      text-align: center;
      color: #ffffff;
      font-size: 60px;
      font-weight: normal;
      margin-bottom: 16px;
      margin-top: 0;
      max-width: 700px;
    }
    [data-type='sub-title'] {
      color: #ffffff;
      text-align: center;
      font-size: 24px;
      font-style: normal;
      font-weight: 500;
      line-height: 36px;
      margin: 0;
      margin-bottom: 60px;
      max-width: 650px;
    }
    [data-type='contact-us-button'] {
      color: #ffffff;
      border: 1px solid #ffffff;
    }
  }

  [data-type='site-section'] {
    position: absolute;
    bottom: 0;
    right: 0;
    text-align: right;
    color: #f3f3f3;
    z-index: 3;
    font-weight: normal;
    padding-right: 50px;
    padding-bottom: 50px;
    [data-type='site-name'] {
      font-size: 24px;
      font-style: normal;
      font-weight: 400;
      line-height: 36px;
      margin: 0;
    }
    [data-type='location'] {
      margin: 0;
      text-transform: uppercase;
      font-size: 14px;
      font-style: normal;
      font-weight: 700;
      line-height: 28px;
      letter-spacing: 2.24px;
      text-transform: uppercase;
    }
    [data-type='photo-courtesy'] {
      width: 210px;
      margin: 0;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 22px;
    }
  }
  &[data-type='commercial'],
  &[data-type='residential'],
  &[data-type='healthcare'],
  &[data-type='hospitality'],
  &[data-type='capabilities'] {
    height: 450px;
    [data-type='image'] {
      height: 450px;
      img {
        height: 450px;
      }
    }
  }

  @media (max-width: ${tabletWidth}px) {
    height: 502px;
    [data-type='image'] {
      height: 502px;
      img {
        height: 502px;
      }
    }
    [data-type='sub-section'] {
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
    }
    &[data-type='commercial'],
    &[data-type='residential'],
    &[data-type='healthcare'],
    &[data-type='hospitality'],
    &[data-type='capabilities'] {
      height: 450px;
      [data-type='image'] {
        height: 450px;
        img {
          height: 450px;
        }
      }
    }
  }
  @media (max-width: ${mobileWidth}px) {
    display: flex;
    height: 440px;
    [data-type='image'] {
      height: 250px;
      width: 100%;
      img {
        height: 250px;
      }
    }
    [data-type='site-section'] {
      display: none;
    }
    [data-type='header'] {
      height: initial;
      h1 {
        font-size: 40px;
        font-style: normal;
        font-weight: 400;
        line-height: 42px;
        margin: 0;
        height: 250px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      [data-type='sub-section'] {
        width: 100%;
        background: #000000;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        padding: 0 16px;
        [data-type='sub-title'] {
          padding-top: 24px;
          margin-bottom: 36px;
          font-size: 16px;
          font-style: normal;
          font-weight: 500;
          line-height: 22px;
        }
        [data-type='contact-us'] {
          width: 100%;
          margin-bottom: 48px;
        }
        [data-type='contact-us-button'] {
          display: flex;
          align-self: center;
          width: 100%;
          height: 44px;
          font-size: 12px;
          font-style: normal;
          font-weight: 600;
          line-height: 28px;
          letter-spacing: 1.92px;
        }
      }
    }
    &[data-type='commercial'],
    &[data-type='residential'],
    &[data-type='healthcare'],
    &[data-type='hospitality'],
    &[data-type='capabilities'] {
      height: 250px;
      [data-type='image'] {
        height: 250px;
        img {
          height: 250px;
        }
      }
      [data-type='header'] {
        h1 {
          margin-top: -35px;
        }
        [data-type='sub-section'] {
          margin-top: -105px;
          background: none;
        }
      }
    }
  }
`